module.exports = __webpack_public_path__ + "static/media/TelaVancouverPcMin.846403b3.jpg";